import { Role } from '../../account';
import { Account } from '../../auth';
import { WorkspaceType } from '../../graphql/enums';

export interface Workspace {
  id: string;
  name: string;
  owner?: Account;
  defaultRole?: Role;
  type?: WorkspaceType;
}
